// extracted by mini-css-extract-plugin
module.exports = {"featureIn":"featuredIn_featureIn____0tA"};